var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24992 19C6.06992 19 5.88992 18.95 5.72992 18.85C5.25992 18.56 5.10992 17.95 5.39992 17.47C5.86992 16.7 6.50992 15.94 7.15992 15.39C7.82992 14.82 8.63992 14.36 9.48992 14.06C10.5699 13.69 11.8199 13.59 13.2099 13.77C14.9699 14.01 16.5399 14.89 17.7599 16.32C17.9199 16.51 18.0799 16.73 18.2299 16.95C18.3299 17.09 18.4299 17.23 18.5199 17.36C18.8599 17.79 18.7899 18.42 18.3599 18.76C17.9299 19.1 17.2999 19.03 16.9599 18.6C16.8399 18.45 16.7199 18.28 16.5999 18.1C16.4799 17.93 16.3599 17.76 16.2399 17.61C15.3399 16.55 14.2299 15.92 12.9499 15.75C11.8699 15.61 10.9299 15.67 10.1499 15.94C9.52992 16.15 8.94992 16.49 8.45992 16.9C7.96992 17.32 7.45992 17.92 7.10992 18.5C6.91992 18.81 6.58992 18.98 6.25992 18.98L6.24992 19Z",
    fill: "#50B84A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 15.65C9.33992 15.65 7.16992 13.48 7.16992 10.82C7.16992 8.15999 9.33992 5.98999 11.9999 5.98999C14.6599 5.98999 16.8299 8.15999 16.8299 10.82C16.8299 13.48 14.6599 15.65 11.9999 15.65ZM11.9999 7.99999C10.4399 7.99999 9.16992 9.26999 9.16992 10.83C9.16992 12.39 10.4399 13.66 11.9999 13.66C13.5599 13.66 14.8299 12.39 14.8299 10.83C14.8299 9.26999 13.5599 7.99999 11.9999 7.99999Z",
    fill: "#50B84A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.49 22 2 17.51 2 12C2 6.49 6.49 2 12 2C17.51 2 22 6.49 22 12C22 17.51 17.51 22 12 22ZM12 4C7.59 4 4 7.59 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/edit-profile.6334a3c36dd4d648d98fc353cae791c5.svg";
export { ForwardRef as ReactComponent };